import { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import { ProductsServiceInterface } from "@modules/products/services/ProductsServiceInterface";

import { ProductsSharedStateKitQueryWrapper } from "./ProductsSharedStateKitQueryWrapper";
import { ProductsSharedStateKitServiceWrapper } from "./ProductsSharedStateKitServiceWrapper";

export class ProductsSharedStateKit {
    public readonly query: ProductsSharedStateKitQueryWrapper;
    public readonly service: ProductsSharedStateKitServiceWrapper;

    constructor(
        productsQuery: ProductsQuery,
        productsService: ProductsServiceInterface
    ) {
        this.query = new ProductsSharedStateKitQueryWrapper(productsQuery);
        this.service = new ProductsSharedStateKitServiceWrapper(
            productsService,
            productsQuery
        );
    }
}
